import { Link, useLocation } from "react-router-dom";

const policyNav = [
  { path: "/policy/privacy", label: "개인정보처리방침" },
  { path: "/policy/terms", label: "이용약관" },
  { path: "/policy/email-refusal", label: "이메일무단수집거부" },
  { path: "/policy/sitemap", label: "사이트맵" },
];

const HeroPolicy = () => {
  const { pathname } = useLocation();
  const activeItem = policyNav.find(item => item.path === pathname);

  return (
    <div className="w-full max-w-full py-8 bg-gradient-to-l mt-36">
      <section className="flex flex-col items-start justify-between mx-auto border-b max-w-container about:flex-row about:items-end">
        {/* 타이틀 영역 */}
        <div className="mb-[2rem] text-black px-[2rem] wide:px-0 about:mb-[2rem]">
          <h1
            className="text-left leading-[1.3] flex flex-col"
            style={{ fontSize: "var(--font-display-large, 5rem)", fontWeight: 700 }}
          >
            <span className="text-[2.2rem] font-medium">정책 안내</span>
            <span>{activeItem?.label ?? "정책 안내"}</span>
          </h1>
        </div>

        {/* 네비게이션 영역 */}
        <nav aria-label="정책 메뉴" className="w-full about:w-auto px-[2rem] wide:px-0">
          <ul className="flex items-center gap-2 m-0 list-none overflow-x-auto whitespace-nowrap scrollbar-hide overscroll-x-contain about:gap-4 about:overflow-visible">
            {policyNav.map(item => {
              const isActive = pathname === item.path;

              return (
                <li key={item.path} className="flex shrink-0">
                  <Link
                    to={item.path}
                    className="relative inline-block pb-4 pr-4 transition-colors about:px-5"
                    style={{
                      fontSize: "var(--font-title-medium, 1.8rem)",
                      color: isActive ? "#032C6D" : "#888",
                      fontWeight: isActive ? 700 : 400,
                    }}
                  >
                    {item.label}

                    {/* 활성화 표시 언더라인 */}
                    {isActive && (
                      <span className="absolute left-0 bottom-0 h-[2px] bg-[#032C6D] w-full" />
                    )}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </section>

      {/* 스크롤바 숨김 */}
      <style>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
};

export default HeroPolicy;
